import axios from "axios";
import Swal from "sweetalert2";
import {encryptMessage } from "../utils/crypto";
 
export const apiPostHelper = async (method, url, data, IsError) => {
  try {
    // Get the token from localStorage
    const token = localStorage.getItem('token');
     const  {encryptedData,ivString } = encryptMessage(JSON.stringify(data)); 
    
    // Set up headers with the token
    const headers = {
      'Content-Type': 'application/json',
    };
     // Prepare the encrypted payload
    const payload = {
      encryptedData,
      iv: ivString, // Send the IV along with the data
    }; 
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    console.log(data,'data');
    const response = await axios({
      method,
      url,
   data:payload,
      headers
    });
    
    return response;
  } catch (error) {
    console.error("API Error:", error);
    // Show error with SweetAlert
    if (!IsError){
    Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message||"Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
    throw error; // Rethrow the error if you want to handle it in the calling code
  }
};

export const apiGetHelper = async (method, url,IsError) => {
  
 
  try {
    const token = localStorage.getItem('token');
    const response = await axios({
      method,
      url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("API Error:", error);
    // Show error with SweetAlert
    if (!IsError){
    Swal.fire({
        title: "Error!",
        text:error?.response?.data?.message|| "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
    throw error; // Rethrow the error if you want to handle it in the calling code
  }
};